module.exports = __webpack_public_path__ + "static/media/PRE CONSTRUCTION.faf30d75.jpg";